import { useState, useEffect, useCallback } from 'react'

import useCallApi from '../../utilities/axios'
import useTranslate from '../../i18n/useTranslate'

export type SearchKeywordType = {
    keyword?: string | null
    submittedType: number | null
    projectType?: number | null
    facultyID?: number | null
    startDate: string | Date
    endDate: string | Date
    userID: number
}

export type FirstTimeDataListType = {
    projectID: number
    receiveDate: string
    projectNumber: string
    projectName: Translation
    projectType: {
        id: number
        name: Translation
    }
    name: Translation
    titleID: number
    title: Translation
    academicPosition: Translation
    isPhD: boolean
    researcherTypeName: Translation
    facultyName: Translation
    approveStatusName: Translation
    submittedTypeName: Translation
    educationLevelName: Translation
}

type Translation = {
    th: string
    en: string
}

export const useSearchFirstTime = () => {
    const [dataList, setDataList] = useState<FirstTimeDataListType[]>([])

    const callApi = useCallApi()

    const searchFirstTime = useCallback(async (values: SearchKeywordType) => {
        const { data } = await callApi.axiosPost({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/dashboard/search/project/firstTime`,
            params: { ...values },
        })
        setDataList(data)
    }, [])

    return {
        dataList,
        setDataList,
        searchFirstTime,
    }
}
